export type AttendanceHourCycle = '12' | '24';

const prefix = 'attendance-hour-cycle-v1-user-';

export function attendanceHourCycleKey(session: string | null): string | null {
  try {
    const data = JSON.parse(session || 'null');
    const id = Number(data?.principal?.id ?? data?.user?.id ?? data?.id);
    return Number.isSafeInteger(id) && id > 0 ? `${prefix}${id}` : null;
  } catch {
    return null;
  }
}

export function readAttendanceHourCycle(storage: Storage): AttendanceHourCycle {
  try {
    const key = attendanceHourCycleKey(storage.getItem('PLS'));
    const saved = key ? storage.getItem(key) : null;
    return saved === '12' ? '12' : '24';
  } catch {
    return '24';
  }
}

export function saveAttendanceHourCycle(
  storage: Storage,
  choice: AttendanceHourCycle
): boolean {
  try {
    const key = attendanceHourCycleKey(storage.getItem('PLS'));
    if (!key) return false;
    storage.setItem(key, choice);
    return true;
  } catch {
    return false;
  }
}

export const attendanceDisplayFormat = (choice: AttendanceHourCycle): string =>
  choice === '12' ? 'h:mm A' : 'HH:mm';

export function formatAttendanceDisplayTime(
  clock: string,
  choice: AttendanceHourCycle
): string {
  const parsed = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(clock);
  if (!parsed) return '';
  if (choice === '24') return clock;
  const hour = Number(parsed[1]);
  return `${hour % 12 || 12}:${parsed[2]} ${hour < 12 ? 'AM' : 'PM'}`;
}

export function parseAttendanceDisplayTime(
  draft: string,
  choice: AttendanceHourCycle
): string | null {
  const text = draft.trim().toUpperCase();
  if (choice === '24') {
    const match = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec(text);
    return match ? `${match[1].padStart(2, '0')}:${match[2]}` : null;
  }
  const match = /^(1[0-2]|0?[1-9])(?::([0-5]\d))?\s*(AM|PM)$/.exec(text);
  if (!match) return null;
  const hour = Number(match[1]) % 12 + (match[3] === 'PM' ? 12 : 0);
  return `${String(hour).padStart(2, '0')}:${match[2] || '00'}`;
}
